module.exports = (__webpack_require__(0))(24);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/models/AccessControlledModel.js from dll-reference girder_lib
// module id = 72
// module chunks = 0